export default function StatTile({ label, value, hint, icon: Icon, tone = "primary", onClick }) {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag className={`stat-tile ${onClick ? "is-clickable" : ""}`} onClick={onClick} type={onClick ? "button" : undefined}>
      {Icon && (
        <span className={`stat-icon tone-${tone}`} aria-hidden="true">
          <Icon size={18} />
        </span>
      )}
      <span className="stat-text">
        <span className="stat-label">{label}</span>
        <span className={`stat-value ${typeof value === "string" && value.length > 8 ? "is-text" : ""}`}>{value}</span>
        {hint && <span className="stat-hint">{hint}</span>}
      </span>
    </Tag>
  );
}
